import axios from 'axios';
import {Message,MessageBox,Notification} from 'element-ui'

let http = axios.create({
    baseURL:'https://v.91360.com/api/fc',
    timeout: 50000,
    params: {
        'lang': 'zh-cn'
    }
})
http.interceptors.response.use(
    (config)=>{
        // Notification({
        //     title: '提交成功',
        //     message:config.data.message,
        //     type: 'success'
        // });
        // MessageBox({
        //     message:config.data.message,
        //     title:'',
        //     type: 'success',
        // })
        // console.log()
        // MessageBox({
        //     message:h('p',null,[
        //     h('span',null,`${config.data.message}数字病理义诊公益平台:`),
        //     h('a',{href:'http://gyw.91360.com/#/home',style:'color: rgb(255, 2, 39);'},'gy.91360.com')
        //     ]),
        //     confirmButtonText:'关闭',
        //     type: 'success',
        // })
        return config.data;
        // if(config.status == 200){
        //     Notification({
        //       title: '提交成功',
        //       message:config.data.message,
        //       type: 'success'
        //     });
        //     return config.data;
        // }else{
        //     Message({
        //         type:"error",
        //         message:config.message
        //     })  
        // }
    },
    (err)=>{
        if(err.response.status=422){
            Message({
                type:"error",
                message:err.response.data.message
            })
        }else{
            Message({
                type:"error",
                message:"提交失败，请联系管理员"
            })
        }
        return Promise.reject(null)
    }
)

export {http}


// WEBPACK FOOTER //
// ./src/http/axiosinstance.js